import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { getParsedJson } from "../common";

// Scores rebalanced so the sum equals exactly 100 points
const scoreData = {
  first_name: 4,
  last_name: 4,
  email: 6,
  mobile_number: 6,
  details: 6,
  languages_known: 5,
  location: 6,
  designation: 6,
  current_salary_per_month: 6, // Mapped to currentSalaryStr or currentSalary
  total_work_experience: 6,
  skills: 6,
  whatsapp_number: 4,
  profile_picture: 7,
  resume: 7,
  permanent_address: 6,
  state: 5,
  qualification: 10,
};

const useProfileCompletion = () => {
  const [completionPercentage, setCompletionPercentage] = useState(0);

  const {
    profile,
    qualifications: reduxQualifications,
    experiences: reduxExperiences,
  } = useSelector((state) => state.customer);

  useEffect(() => {
    console.log("Profile API Response:@", profile);
  }, [profile]);

  const customerAdditional = getParsedJson(profile, null);

  const isValidValue = (val) => {
    if (val === undefined || val === null) return false;

    if (typeof val === "string") {
      const cleanText = val.replace(/<[^>]*>/g, "").trim();
      if (!cleanText || cleanText === "string" || cleanText === "[]") {
        return false;
      }
      return true;
    }

    if (Array.isArray(val)) {
      return val.length > 0;
    }

    return String(val).trim() !== "";
  };

  const hasCompletedRequiredFields = (formData) => {
    const requiredFields = [
      "first_name",
      "last_name",
      "email",
      "mobile_number",
      "designation",
      "location",
      "current_salary_per_month",
      "total_work_experience",
      "skills",
    ];

    for (const field of requiredFields) {
      if (!isValidValue(formData[field])) {
        console.log("Incomplete required field:", field);
        return false;
      }
    }

    return true;
  };

  const getProfileCompletion = useCallback(
    (payload) => {
      let formData = {};

      if (payload) {
        formData = { ...payload };
      } else {
        const profileData = profile?.data || {};

        let parsedQualifications = [];
        if (profileData?.qualifications) {
          try {
            parsedQualifications =
              typeof profileData.qualifications === "string"
                ? JSON.parse(profileData.qualifications)
                : profileData.qualifications;
          } catch (e) {
            parsedQualifications = [];
          }
        } else if (reduxQualifications?.length) {
          parsedQualifications = reduxQualifications;
        }

        formData = {
          first_name: profileData?.firstName || "",
          last_name: profileData?.lastName || "",

          email: profileData?.email || profile?.email || "",
          mobile_number: profileData?.phoneNumber || profile?.mobile_number || "",

          details: profileData?.details || "",

          languages_known:
            profileData?.languagesknow || profileData?.languagesKnown || "",

          location: profileData?.location || "",
          designation: profileData?.designation || "",

          // Uses currentSalaryStr first, falls back to currentSalary if string exists
          current_salary_per_month:
            profileData?.currentSalaryStr ||
            (profileData?.currentSalary != null && profileData?.currentSalary !== ""
              ? String(profileData.currentSalary)
              : ""),

          total_work_experience: profileData?.totalWorkExperience || "",

          skills: profileData?.skills || "",

          whatsapp_number: profileData?.whatsappNumber || "",

          profile_picture: profileData?.profileImage || "",

          permanent_address: profileData?.permanentAddress || "",

          state: profileData?.state || "",

          resume: profileData?.resumeFile || profileData?.resume || "",

          qualification:
            Array.isArray(parsedQualifications) && parsedQualifications.length > 0
              ? parsedQualifications
              : "",
        };
      }

      const totalScore = Object.values(scoreData).reduce(
        (acc, value) => acc + value,
        0
      );

      let completedFields = 0;

      for (const field in scoreData) {
        const value = formData[field];
        const isFilled = isValidValue(value);

        console.log(
          `Field: ${field}`,
          "| Value:", value,
          "| Filled:", isFilled ? "✅ YES" : "❌ NO",
          "| Score:", isFilled ? scoreData[field] : 0
        );

        if (isFilled) {
          completedFields += scoreData[field];
        }
      }

      const percentage = Math.min(
        100,
        Math.round((completedFields / totalScore) * 100)
      );
      
      setCompletionPercentage(percentage);

      return percentage;
    },
    [profile, reduxQualifications]
  );

  useEffect(() => {
    getProfileCompletion();
  }, [profile, customerAdditional, getProfileCompletion]);

  return {
    completionPercentage,
    getProfileCompletion,
    hasCompletedRequiredFields,
  };
};

export default useProfileCompletion;